<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-item">
        <div class="title">Kredit Pintar</div>
        <a class="text" target="_blank" href="https://loan.kreditpintar.com">
          {{ $t('borrower') }}
        </a>
      </div>
      <div class="footer-item">
        <div class="title">{{ $t('contactUs') }}</div>
        <div class="local">
          <md-icon name="location" size="sm"></md-icon>
          Jakarta Office
        </div>
        <div class="text">
          Treasury tower lantai 53 (PT Kredit Pintar Indonesia)<br>
          Jl. Tulodong Atas 6 No.47, RT.5/RW.3, Senayan, Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta
          12190
        </div>
      </div>
      <div class="footer-item">
        <div class="title">{{ $t('lender') }}</div>
        <div class="text">
          <div v-if="!$config.needElectronicContract">{{ $t('whatsapp') }}: 081324887208<br></div>
          <div>
            E-mail:
            <a href="mailto:cs@kreditpintar.com" class="text email">
              pendanaan@kreditpintar.com
            </a>
          </div>
          <div>{{ $t('workingHours') }}</div>
        </div>
      </div>
      <div class="footer-item">
        <div class="title">{{ $t('borrower') }}</div>
        <div class="text">
          {{ $t('telephone') }}: (021) 50598882<br>
          E-mail:
          <a href="mailto:cs@kreditpintar.com" class="text email">
            cs@kreditpintar.com
          </a>
        </div>
      </div>
      <div class="app-download" v-if="!$config.needElectronicContract">
        <div class="title">{{$t('getLenderApp')}}</div>
        <div class="download-link">
          <a href="https://itunes.apple.com/app/id1440695805">
            <img src="@/assets/image/home/footer/apple-store.png" class="download-icon">
          </a>
          <a href="https://kplender.onelink.me/3lte/37821b57">
            <img src="@/assets/image/home/footer/google-play.png" class="download-icon">
          </a>
        </div>
      </div>
      <div class="copyright">
        © 2019 PT Kredit Pintar Indonesia. All rights reserved.Please find
        <a :href="`/static/html/term-of-service/term-of-service-${$i18n.locale}.html`" class="link" target="_blank">
          Terms and Conditions
        </a>
        and
        <a :href="`/static/html/privacy-policy/privacy-policy-${$i18n.locale}.html`" class="link" target="_blank">
          Privacy Policy
        </a>.
        regarding Kredit Pintar's service.
      </div>
      <div class="agency">
        <div class="agency-title">{{ $t('sloganTip') }}</div>
        <img class="agency-logo" src="@/assets/image/home/banner/flag-mb.png" alt="">
      </div>
      <div class="legel">
        <div style="height: 15px;"></div>
        <h3 style="font-size: 16px; font-weight: normal; margin-bottom: 10px;">{{ $t('attention') }}</h3>
        <ol>
          <li>1. {{ $t('footerTip1') }}</li>
          <li>2. {{ $t('footerTip2') }}</li>
          <li>3. {{ $t('footerTip3') }}</li>
          <li>4. {{ $t('footerTip4') }}</li>
          <li>5. {{ $t('footerTip5') }}</li>
          <li>6. {{ $t('footerTip6') }}</li>
          <li>7. {{ $t('footerTip7') }}</li>
          <li>8. {{ $t('footerTip8') }}</li>
          <li>9. {{ $t('footerTip9') }}</li>
        </ol>
      </div>
      <div class="security-policy">
        <div class="security-label">{{ $t('securityLabel') }}</div>
        <div class="security-list">
          <div>{{ $t('security1') }}</div>
          <div>{{ $t('security2') }}</div>
          <div>{{ $t('security3') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        attention: 'ATTENTION:',
        borrower: 'Borrower',
        lender: 'Lender',
        contactUs: 'Contact Us',
        faq: 'FAQ',
        getLenderApp: 'Get the Lender App',
        footerTip1: 'Layanan Pinjam Meminjam Berbasis Teknologi Informasi merupakan kesepakatan perdata antara Pemberi Pinjaman dengan Penerima Pinjaman, sehingga segala risiko yang timbul dari kesepakatan tersebut ditanggung sepenuhnya oleh masing-masing pihak.',
        footerTip2: 'Resiko Pinjaman atau Gagal Bayar dan seluruh kerugian dari atau terkait dengan kesepakatan pinjam meminjam ditanggung sepenuhnya oleh Pemberi Pinjaman. Tidak ada lembaga atau otoritas negara yang bertanggung jawab atas resiko gagal bayar dan kerugian tersebut.',
        footerTip3: 'Penyelenggara dengan persetujuan dari masing-masing Pengguna (Pemberi Pinjaman dan/atau Penerima Pinjaman) mengakses, memperoleh, menyimpan, mengelola dan/atau menggunakan data pribadi Pengguna (\'Pemanfaatan Data\') pada atau di dalam benda, perangkat elektronik (termasuk smartphone atau telepon seluler), perangkat keras (hardware) maupun lunak (software), dokumen elektronik, aplikasi atau sistem elektronik milik Pengguna atau yang dikuasai Pengguna, dengan memberitahukan tujuan, batasan dan mekanisme Pemanfaatan Data tersebut kepada Pengguna yang bersangkutan sebelum memperoleh persetujuan yang dimaksud.',
        footerTip4: 'Pemberi Pinjaman yang belum memiliki pengetahuan dan pengalaman pinjam meminjam, disarankan untuk tidak menggunakan layanan ini.',
        footerTip5: 'Penerima Pinjaman harus mempertimbangkan tingkat bunga pinjaman dan biaya lainnya sesuai dengan kemampuan dalam melunasi pinjaman.',
        footerTip6: 'Setiap kecurangan tercatat secara digital di dunia maya dan dapat diketahui masyarakat luas di media sosial.',
        footerTip7: 'Pengguna harus membaca dan memahami informasi ini sebelum membuat keputusan menjadi Pemberi Pinjaman atau Penerima Pinjaman',
        footerTip8: 'Pemerintah yaitu dalam hal ini Otoritas Jasa Keuangan,tidak bertanggung jawab atas setiap pelanggaran atau ketidakpatuhan oleh Pengguna,baik Pemberi Pinjaman maupun Penerima Pinjaman(baik karena kesengajaan atau kelalaian Pengguna)terhadap ketentuan peraturan perundang-undangan maupun kesepakatan atau perikatan antara Penyelenggara dengan Pemberi Pinjaman dan/atau Penerima Pinjaman.',
        footerTip9: 'Setiap transaksi dan kegiatan pinjam meminjam atau pelaksanaan kesepakatan mengenai pinjam meminjam antara atau yang melibatkan Penyelenggara,Pemberi Pinjaman dan/atau Penerima Pinjaman wajib dilakukan melalui escrow account dan virtual account sebagai mana yang diwajibkan berdasarkan Peraturan Otoritas Jasa Keuangan Nomor77/POJK.01/2016 tentang Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi dan pelanggaran atau ketidakpatuhan terhadap ketentuan tersebut merupakan bukti telah terjadinya pelanggaran hukum oleh Penyelenggara sehingga Penyelenggara wajib menanggung ganti rugi yang diderita oleh masing-masing Pengguna sebagai akibat langsung dari pelanggaran hukum tersebut diatas tanpa mengurangi hak Pengguna yang menderita kerugian menurut Kitab Undang-Undang Hukum Perdata.',
        sloganTip: 'Registered with and Monitored by',
        telephone: 'Telephone',
        whatsapp: 'Whatsapp',
        workingHours: 'Working Hours: Monday-Friday 09:30-19:30',
        securityLabel: 'In relation of Kredit Pintar commitment in implementing Information Security, here are the list of Information Security Policy:',
        security1: '1. Fulfilling Stakeholder expectation by realizing information Confidentiality, Integrity, and Availability by implementing ISO/IEC 27001: 2013 ISMS.',
        security2: '2. Always following any rules and regulation regarding information security that is valid in Indonesia.',
        security3: '3. Continuous improvement of Information Security Management System.',
      },
      id: {
        attention: 'PERHATIAN:',
        borrower: 'Peminjam',
        lender: 'Pemberi pinjaman',
        contactUs: 'Hubungi Kami',
        faq: 'FAQ',
        getLenderApp: 'Unduh aplikasi pendanaan',
        footerTip1: 'Layanan Pinjam Meminjam Berbasis Teknologi Informasi merupakan kesepakatan perdata antara Pemberi Pinjaman dengan Penerima Pinjaman, sehingga segala risiko yang timbul dari kesepakatan tersebut ditanggung sepenuhnya oleh masing-masing pihak.',
        footerTip2: 'Resiko Pinjaman atau Gagal Bayar dan seluruh kerugian dari atau terkait dengan kesepakatan pinjam meminjam ditanggung sepenuhnya oleh Pemberi Pinjaman. Tidak ada lembaga atau otoritas negara yang bertanggung jawab atas resiko gagal bayar dan kerugian tersebut.',
        footerTip3: 'Penyelenggara dengan persetujuan dari masing-masing Pengguna (Pemberi Pinjaman dan/atau Penerima Pinjaman) mengakses, memperoleh, menyimpan, mengelola dan/atau menggunakan data pribadi Pengguna (\'Pemanfaatan Data\') pada atau di dalam benda, perangkat elektronik (termasuk smartphone atau telepon seluler), perangkat keras (hardware) maupun lunak (software), dokumen elektronik, aplikasi atau sistem elektronik milik Pengguna atau yang dikuasai Pengguna, dengan memberitahukan tujuan, batasan dan mekanisme Pemanfaatan Data tersebut kepada Pengguna yang bersangkutan sebelum memperoleh persetujuan yang dimaksud.',
        footerTip4: 'Pemberi Pinjaman yang belum memiliki pengetahuan dan pengalaman pinjam meminjam, disarankan untuk tidak menggunakan layanan ini.',
        footerTip5: 'Penerima Pinjaman harus mempertimbangkan tingkat bunga pinjaman dan biaya lainnya sesuai dengan kemampuan dalam melunasi pinjaman.',
        footerTip6: 'Setiap kecurangan tercatat secara digital di dunia maya dan dapat diketahui masyarakat luas di media sosial.',
        footerTip7: 'Pengguna harus membaca dan memahami informasi ini sebelum membuat keputusan menjadi Pemberi Pinjaman atau Penerima Pinjaman',
        footerTip8: 'Pemerintah yaitu dalam hal ini Otoritas Jasa Keuangan,tidak bertanggung jawab atas setiap pelanggaran atau ketidakpatuhan oleh Pengguna,baik Pemberi Pinjaman maupun Penerima Pinjaman(baik karena kesengajaan atau kelalaian Pengguna)terhadap ketentuan peraturan perundang-undangan maupun kesepakatan atau perikatan antara Penyelenggara dengan Pemberi Pinjaman dan/atau Penerima Pinjaman.',
        footerTip9: 'Setiap transaksi dan kegiatan pinjam meminjam atau pelaksanaan kesepakatan mengenai pinjam meminjam antara atau yang melibatkan Penyelenggara,Pemberi Pinjaman dan/atau Penerima Pinjaman wajib dilakukan melalui escrow account dan virtual account sebagai mana yang diwajibkan berdasarkan Peraturan Otoritas Jasa Keuangan Nomor77/POJK.01/2016 tentang Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi dan pelanggaran atau ketidakpatuhan terhadap ketentuan tersebut merupakan bukti telah terjadinya pelanggaran hukum oleh Penyelenggara sehingga Penyelenggara wajib menanggung ganti rugi yang diderita oleh masing-masing Pengguna sebagai akibat langsung dari pelanggaran hukum tersebut diatas tanpa mengurangi hak Pengguna yang menderita kerugian menurut Kitab Undang-Undang Hukum Perdata.',
        sloganTip: 'Terdaftar dan diawasi oleh',
        telephone: 'Telepon',
        whatsapp: 'Whatsapp',
        workingHours: 'Jam Kerja: Senin-Jumat 09:30-19:30',
        securityLabel: 'Dalam hal bentuk komitmen kredit pintar dalam penerapan Keamanan Informasi, berikut adalah Kebijakan Keamanan Informasi yang kami tetapkan:',
        security1: '1. Memenuhi harapan Stakeholder dengan mewujudkan Confidentiality, Integrity dan Availlability informasi melalui implementasi ISO/IEC 27001:2013 ISMS.',
        security2: '2. Selalu mentaati segala ketentuan dan peraturan terkait keamanan informasi yang berlaku di wilayah Republik Indonesia serta wilayah tempat dilakukannya pekerjaan.',
        security3: '3. Berjalannya perbaikan yang berkesinambungan terhadap kinerja Sistem Manajemen Keamananan Informasi.',
      },
    },
  },
}
</script>

<style lang="stylus" scoped>
.footer {
  background-color: #E8E8E8;
  background-size: cover;
  min-height: 450px;
  padding: 64px 0;
  font-weight: 200;
  letter-spacing: 1;
}

.footer-content {
  padding: 0 16px;
  margin: 0 auto;
  .footer-item {
    margin-bottom: 15px;
  }
  .title {
    color: #555;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .text {
    font-size: 12px;
    color: #333;
    text-decoration: none;
    display: block;
    line-height: 16px;
    &.email {
      display: inline-block;
    }
  }
}

.copyright {
  opacity: 0.7;
  font-size: 12px;
  padding: 18px 0;
  border-bottom: 1px solid #c9c9c9;
}

.legel {
  opacity: 0.8;
  font-size: 12px;
  line-height: 18px;
}

.legel ol {
  padding-left: 10px;
}

.legel li {
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
}

.local {
  color: #999;
  margin-bottom: 8px;
  font-size: 12px;
}

.link {
  font-size: 12px;
  color: #333;
  text-decoration: underline;
  line-height: 16px;
}

.agency {
  padding: 24px 0;
  .agency-title {
    margin-bottom: 24px;
  }
  .agency-logo {
    width: 100px;
    height: 40px;
  }
}

.download-link {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
  .download-icon {
    &:first-child {
      margin-right: 12px;
    }
    width: 102px;
    height: 32px;
  }
}

.security-label
  font-size 14px
  line-height 16px
  margin-top 30px
  margin-bottom 10px

.security-list
  font-size 12px
  div
    padding-left 10px
    line-height 14px
    margin-bottom 10px
    letter-spacing 0.5px
</style>
